import { AbstractService, ChallengeValidation, } from '@standardnotes/services';
import { SettingName } from '@standardnotes/domain-core';
export class MfaService extends AbstractService {
    constructor(settingsService, featuresService, protections, encryption, internalEventBus) {
        super(internalEventBus);
        this.settingsService = settingsService;
        this.featuresService = featuresService;
        this.protections = protections;
        this.encryption = encryption;
        this.internalEventBus = internalEventBus;
    }
    async isMfaActivated() {
        const mfaSetting = await this.settingsService.getDoesSensitiveSettingExist(SettingName.create(SettingName.NAMES.MfaSecret).getValue());
        return mfaSetting != false;
    }
    async generateMfaSecret() {
        return this.settingsService.generateMfaSecret();
    }
    async enableMfa(secret, otpToken) {
        return this.settingsService.updateMfaSetting(secret, otpToken);
    }
    async disableMfa() {
        const { success, challengeResponse } = await this.protections.authorizeMfaDisable();
        if (!success) {
            return;
        }
        const password = challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.getValueForType(ChallengeValidation.AccountPassword).value;
        const currentRootKey = await this.encryption.computeRootKey(password, this.encryption.getRootKeyParams());
        const serverPassword = currentRootKey.serverPassword;
        return await this.settingsService.deleteSetting(SettingName.create(SettingName.NAMES.MfaSecret).getValue(), serverPassword);
    }
    deinit() {
        ;
        this.settingsService = undefined;
        this.featuresService = undefined;
        super.deinit();
    }
}
